export type MissingSadaratGenderScope = "all" | "male" | "female";

/** Choices for Allocate sadarat List `SelectInput` (URL-synced filter). */
export const MISSING_SADARAT_GENDER_CHOICES = [
  { id: "male", name: "Male" },
  { id: "female", name: "Female" },
] as const;

/** Normalize list filter / URL value to a gender scope. */
export function parseMissingSadaratGenderScope(value: unknown): MissingSadaratGenderScope {
  if (value === "male" || value === "female") return value;
  return "all";
}

/** Query filter fragment for allocate-sadarat gender (omit when `all`). */
export function missingSadaratGenderFilter(scope: MissingSadaratGenderScope): {
  missingSadaratGender?: "male" | "female";
} {
  if (scope === "male" || scope === "female") {
    return { missingSadaratGender: scope };
  }
  return {};
}
